<template>
  <Slide right >
    <a id="home" href="#">
      <span>
        <img v-if="!user.medical_dashboard_logo_url" :src="require(`../assets/images/${logo}`)" height="70" alt="Icon">
        <img v-else :src="user.medical_dashboard_logo_url" height="70" alt="Icon">
      </span>
    </a>
    <!-- Alarms list in side menu -->
    <a >
      <font-awesome-icon icon="comments" /> &nbsp;
      <span @click="showModal({componentName: 'PatientInfo', modalTitle: $t('patient-settings'), modalData: {activeTab: 1}})">{{$t('alarms-list')}}</span>
    </a>
    <!-- Alarms settings in side menu -->
    <a>
      <font-awesome-icon icon="toggle-on" />  &nbsp;
      <span @click="showModal({componentName: 'PatientInfo', modalTitle: $t('patient-settings'), modalData: {activeTab: 2}})">{{$t('alarms-settings')}}</span>
    </a>
    <!-- History/Graphs in side menu -->
    <a>
      <font-awesome-icon icon="history" /> &nbsp;
      <span @click="showModal({componentName: 'PatientInfo', modalTitle: $t('patient-settings'), modalData: {activeTab: 3}})">{{$t('History')}}</span>
    </a>
    <!-- Patient Settings in side menu -->
    <a>
      <font-awesome-icon icon="address-card" />   &nbsp;
      <span @click="showModal({componentName: 'PatientInfo', modalTitle: $t('patient-settings'), modalData: {activeTab: 4}})">{{$t('patient-settings')}}</span>
    </a>
    <!-- Reports in side menu -->
    <a class="disabled">
      <font-awesome-icon icon="file-medical" /> &nbsp;
      <span @click="$notify({text: $t('Will be integrated in next version'), type: 'warn'})">{{$t('patient-report')}}</span>
<!--      <span @click="showModal({componentName: 'Reports', modalTitle: $t('patient-report')})">{{$t('patient-report')}}</span>-->
    </a>
    <!-- Settings of the site in side menu -->
    <a>
      <font-awesome-icon icon="tools" />
      <span @click="showModal({componentName: 'Settings', modalTitle: $t('edit-settings')})">{{$t('edit-settings')}}</span>
    </a>
    <!-- Sms log of the site in side menu -->
    <a v-if="user.features.smsLog">
      <font-awesome-icon icon="mobile" />
      <span @click="showModal({componentName: 'SmsLog', modalTitle: $t('sms-log-title')})">{{$t('sms-log')}}</span>
    </a>
    <!-- Logout in side menu -->
    <router-link v-if="authenticated" to="/Login" v-on:click.native="logout()" replace><font-awesome-icon icon="power-off" /> &nbsp;   {{$t('Logout')}}</router-link>
  </Slide>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import { Slide } from 'vue-burger-menu'

export default {
  name: "SliderMenu",
  data() {
    return {
      authenticated: sessionStorage.getItem('authenticated') === 'true',
      logo: process.env.VUE_APP_LOGO_IMAGE
    }
  },
  components: {
    Slide
  },
  computed: {
    ...mapState(['user'])
  },
  methods:{
    //Logout of site from side menu
    logout() {
      sessionStorage.clear()
      this.$router.go({ name: 'Login' })
    },
    ...mapMutations(['showModal']),
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SliderMenu.vue